/* pages.js
--------------------------------------------------------------------------------

PAGES JAVASCRIPT [ TABLE OF CONTENTS ]


VARIABLES
--------------------------------------------------------------------------------
Main Variables


TEMPlATES
--------------------------------------------------------------------------------
1.1   Sort Templates Fields
1.2		Input Fields Selection

MEDIA LIBRARY
--------------------------------------------------------------------------------
2.1   Sidebar Inspector

FLOW EDITOR
--------------------------------------------------------------------------------
3.1   Flow Editor Sidebar


INIT FUNCTIONS
--------------------------------------------------------------------------------
A.1   Window Load Function
A.2   Document Ready Function
A.3   Window Resize Function

--------------------------------------------------------------------------------
*/


(function($) {
	"use strict";

  // VARIABLES
  // ---------------------------------------------------------------------------

  // TEMPLATES
  // ---------------------------------------------------------------------------
  // 1.1  Sort Templates Fields
  function init_sortTemplateFields() {
    var templateFields = document.getElementById('template-fields');
    if(templateFields){
      var sortable = Sortable.create(templateFields, {
        handle: ".field-handle",
        draggable: ".field-item",
        ghostClass: "field-ghost",
	      chosenClass: "field-chosen",
	      dragClass: "field-drag"
      });
    }
	}

	// 1.2		Input Fields Selection
	function init_inputFieldsSelection() {
    var inputFields = document.getElementById('inputFieldsGroup');
    if(inputFields){
			$('#templateNewField .fields-group .field').click(function() {
		    $('#templateNewField .fields-group .field').removeClass('active');
		    $(this).addClass('active');
				if($(this).hasClass('reference')){
					$('#templateNewField .new-field-options .option-for-default').addClass('hide');
					$('#templateNewField .new-field-options .option-for-reference').removeClass('hide');
				}else{
					$('#templateNewField .new-field-options .option-for-default').removeClass('hide');
					$('#templateNewField .new-field-options .option-for-reference').addClass('hide');
				}
				event.preventDefault();
		  });
    }
	}

	// MEDIA LIBRARY
  // ---------------------------------------------------------------------------
  // 2.1  Sidebar Inspector
	function init_sidebarInspector() {
    $('.btn-inspector').click(function(){
			$('.media-library').toggleClass('ml-sidebar-active');
		});
	}

	// 2.2	Media Lib Actions
	function init_mediaLibActions() {
    $(".ml-filter-sorting .btn").click(function() {
      $(".ml-filter-sorting .btn").not(this).removeClass("active");
      $(this).addClass("active");
    });

		$(".ml-filter-view .btn").click(function() {
      $(".ml-filter-view .btn").not(this).removeClass("active");
      $(this).addClass("active");
			if( $(this).hasClass("btn-show-rows") ){
				$('.media-library').addClass('ml-rows-active');
			}else{
				$('.media-library').removeClass('ml-rows-active');
			}
    });

		$(".ml-item-folder").dblclick(function() {
		  window.document.location = $(this).data("href");
		});

		$(".ml-item").click(function() {
		  $('.ml-sidebar-body').load($(this).data("inspector"));
			$('.media-library').addClass('ml-sidebar-active');
			$('.btn-move-to-folder').attr('disabled', false);
		});

		$(".btn-move-to-folder").click(function() {
		  $('.ml-sidebar-body').load("/cms/media/inspector/treeview/");
		});

		$(".ml-item .ml-i-rename a").click(function() {
			var currentItem = $(this).closest('li');

			if(currentItem.hasClass('ml-item-edit')){
				currentItem.find('.ml-i-name input').attr('readonly', true);
				currentItem.removeClass('ml-item-edit');
			}else{
				$('.media-lib-items .ml-item').not(currentItem).removeClass('ml-item-edit');
				$('.media-lib-items .ml-item').not(currentItem).find('.ml-i-name input').attr('readonly', true);
				currentItem.addClass('ml-item-edit');
				currentItem.find('.ml-i-name input').attr('readonly', false);
			}
		});

		$(".ml-item-edit .ml-i-rename a").click(function() {
			$(this).closest('li').removeClass('ml-item-edit');
			$(this).closest('li').find('.ml-i-name input').attr('readonly', true);
		});

		$(document).click(function (e) {
	    if (
				$(e.target).closest(".media-lib-items li").length === 0 &&
				$(e.target).closest(".media-lib-sidebar").length === 0 &&
				$(e.target).closest(".btn-move-to-folder").length === 0
			){
				$('.ml-sidebar-body').load("/cms/media/inspector/default/");
				$('.media-lib-items .ml-item').removeClass('ml-item-edit');
				$('.media-lib-items .ml-item:not(.ml-item-add-folder) .ml-i-name input').attr('readonly', true);
				$('.btn-move-to-folder').attr('disabled', true);
	    }
		});

		const fileSelect = document.getElementById("fileSelect"),
	  fileElem = document.getElementById("fileElem");
		fileSelect.addEventListener("click", function (e) {
		  if (fileElem) {
		    fileElem.click();
		  }
		}, false);



	}

	// 2.3 Media Lib Sortable
	function init_mediaLibSortable() {
		var mediaLibContainer = document.getElementById('media-lib-container');
    if(mediaLibContainer){
      var sortable = Sortable.create(mediaLibContainer, {
        //handle: ".field-handle",
        //draggable: ".field-item",
        //ghostClass: "field-ghost",
	      //chosenClass: "field-chosen",
	      //dragClass: "field-drag"
				multiDrag: true, // Enable multi-drag
				selectedClass: 'selected', // The class applied to the selected items
				animation: 150,
				multiDragKey: 'alt'
      });
    }
	}

	// 2.4 Add Folder
	function init_addMediaLibFolder() {
		$(".btn-add-folder").click(function() {
		  $('.media-lib-items').prepend('<li class="ml-item ml-item-folder ml-item-add-folder" data-inspector="/cms/media/inspector/untitled-folder/"><div class="ml-item-thumb"><div class="ml-item-thumb-inner"><i class="fa fa-folder"></i></div></div><div class="ml-item-details"><div class="ml-i-name"><input type="text" name="ml-i-name-input" value="Untitled Folder"></div><div class="ml-i-rename"><a href="#"><i class="fa fa-terminal"></i></a></div></div></li>');
			$(".ml-item-add-folder").click(function() {
			  $('.ml-sidebar-body').load($(this).data("inspector"));
				$('.media-library').addClass('ml-sidebar-active');
			});
			$(".ml-item-add-folder .ml-i-rename a").click(function() {
				var currentItem = $(this).closest('li');

				if(currentItem.hasClass('ml-item-add-folder')){
					currentItem.find('.ml-i-name input').attr('readonly', true);
					currentItem.removeClass('ml-item-add-folder');
				}else if(currentItem.hasClass('ml-item-edit')){
					currentItem.find('.ml-i-name input').attr('readonly', true);
					currentItem.removeClass('ml-item-edit');
				}else{
					$('.media-lib-items .ml-item').not(currentItem).removeClass('ml-item-edit');
					$('.media-lib-items .ml-item').not(currentItem).find('.ml-i-name input').attr('readonly', true);
					currentItem.addClass('ml-item-edit');
					currentItem.find('.ml-i-name input').attr('readonly', false);
				}
			});
		});
	}

	function exec_deleteFile() {
		Swal.fire({
			title: 'Are you sure?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!'
		}).then((result) => {
			if (result.value) {
				Swal.fire(
					'Deleted!',
					'Your file has been deleted.',
					'success'
				)
			}
		});
	}

	// FLOW EDITOR
  // ---------------------------------------------------------------------------
  // 3.1  Flow Editor
	function init_flowEditor() {
		$('.filter-action').click(function(){
			$('.page-filter').toggleClass('filter-active');
		});

		$('.fc-toggle-btn').click(function(){
			$('.flow-console').toggleClass('is-active');
		});

		// This prevents the Bootstrap Dropdown Menu to close when we click inside
		$(".dd-menu-filter").click(function(e){
   		e.stopPropagation();
		});
	}

	// MIGRATION
  // ---------------------------------------------------------------------------
  // 4.1  Sort Migration Blocks
  function init_sortMigrationBlocks() {
    var migrationBlocks = document.getElementById('migration-blocks');
    if(migrationBlocks){
      var sortable = Sortable.create(migrationBlocks, {
        handle: ".block-handle",
        draggable: ".object-item",
        ghostClass: "block-ghost",
	      chosenClass: "block-chosen",
	      dragClass: "block-drag"
      });
    }
	}
	// 4.2	Add Blocks Selection
	function init_addBlocksSelection() {
    var inputFields = document.getElementById('blocksGroup');
    if(inputFields){
			$('#newBlock .blocks-group .block').click(function() {
		    $('#newBlock .blocks-group .block').removeClass('active');
		    $(this).addClass('active');
				event.preventDefault();
		  });
    }
	}

	// 4.2 Choices
	function init_choicesIpunts() {
		if($('#choices-multiple-tsm').length){
			var multipleCancelButton = new Choices('#choices-multiple-tsm', {
	      removeItemButton: true,
	    });
		}
	}

  // INIT FUNCTIONS

  // ---------------------------------------------------------------------------
  // A.1  WINDOW LOAD FUNCTIONS

  $(window).on('load', function() {

	});


  // ---------------------------------------------------------------------------
	// A.2 DOCUMENT READY FUNCTIONS

	jQuery(document).ready(function($) {

    init_sortTemplateFields();             // 1.1  Sort Model Fields
		init_inputFieldsSelection();					 // 1.2	 Input Fields Selection

		init_sidebarInspector();							 // 2.1  Sidebar Inspector
		init_mediaLibActions();
		init_mediaLibSortable();
		init_addMediaLibFolder();

		init_flowEditor();							 			 // 3.1  Flow Editor


		init_sortMigrationBlocks();						 // 4.1  Sort Migration Blocks
		init_addBlocksSelection();

		init_choicesIpunts();

	});


  // ---------------------------------------------------------------------------
	// A.3 WINDOW RESIZE FUNCTIONS

  $(window).on('resize', function () {

	});

})(jQuery);
